import React from 'react'
import { OutlineBadge } from 'components'
import { TenantType } from 'generated/types'

type Tenant = TenantType

/**
 * Badge cell shows the tenant label (with its color) for the given row.
 */
export type BadgeCellProps = {
	tenant?: Tenant | null
}

const BadgeCell: React.FC<BadgeCellProps> = ({ tenant }) => {
	if (!tenant) return null
	return (
		<OutlineBadge color={tenant.hexColor} small>
			{tenant.name}
		</OutlineBadge>
	)
}

export default BadgeCell
